import {
  PaginatedResponse,
  CustomerRead,
  CustomerCreate,
  CustomerUpdate,
  CustomerBankRead,
  CustomerBankCreate,
  CustomerBankUpdate,
  CustomerContactRead,
  CustomerContactCreate,
  CustomerContactUpdate
} from './types';

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/v1`;

async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('token');
  const headers: HeadersInit = {
    ...(token ? { 'Authorization': token } : {}),
    'Accept': 'application/json',
  };

  if (options.body && typeof options.body === 'string') {
    (headers as Record<string, string>)['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers: { ...headers, ...options.headers },
  });

  if (res.status === 401) throw new Error('Сессия истекла. Пожалуйста, войдите снова.');
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
  if (res.status === 204) return null as T;

  return res.json();
}

// --- Заказчики ---
export async function fetchCustomers(page = 1, size = 20): Promise<PaginatedResponse<CustomerRead>> {
  return request(`/organizations/?page=${page}&size=${size}`);
}

export async function fetchCustomer(id: number): Promise<CustomerRead> {
  return request(`/organizations/${id}/`);
}

export async function createCustomer(data: CustomerCreate): Promise<CustomerRead> {
  return request('/organizations/', { method: 'POST', body: JSON.stringify(data) });
}

export async function updateCustomer(id: number, data: CustomerUpdate): Promise<CustomerRead> {
  return request(`/organizations/${id}/`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deleteCustomer(id: number): Promise<void> {
  return request(`/organizations/${id}/`, { method: 'DELETE' });
}

// --- Банковские реквизиты Заказчика ---
export async function fetchBankRequisites(orgId: number, includeInactive = false): Promise<CustomerBankRead[]> {
  return request(`/organizations/${orgId}/bank-requisites/?include_inactive=${includeInactive}`);
}

export async function createBankRequisite(orgId: number, data: CustomerBankCreate): Promise<CustomerBankRead> {
  return request(`/organizations/${orgId}/bank-requisites/`, { method: 'POST', body: JSON.stringify(data) });
}

export async function updateBankRequisite(reqId: number, data: CustomerBankUpdate): Promise<CustomerBankRead> {
  return request(`/bank-requisites/${reqId}/`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deleteBankRequisite(reqId: number): Promise<void> {
  return request(`/bank-requisites/${reqId}/`, { method: 'DELETE' });
}

export async function setDefaultBankRequisite(reqId: number): Promise<void> {
  return request(`/bank-requisites/${reqId}/set-default/`, { method: 'PATCH' });
}

// --- Контакты заказчика ---
export async function fetchContacts(orgId: number, onlyActive = true, onlySignatories = false): Promise<CustomerContactRead[]> {
  return request(`/organizations/${orgId}/contacts/?only_active=${onlyActive}&only_signatories=${onlySignatories}`);
}

export async function createContact(orgId: number, data: CustomerContactCreate): Promise<CustomerContactRead> {
  return request(`/organizations/${orgId}/contacts/`, { method: 'POST', body: JSON.stringify(data) });
}

export async function updateContact(contactId: number, data: CustomerContactUpdate): Promise<CustomerContactRead> {
  return request(`/contacts/${contactId}/`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deleteContact(contactId: number): Promise<void> {
  return request(`/contacts/${contactId}/`, { method: 'DELETE' });
}